import * as React from "react";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Grid,
  Typography,
  useMediaQuery,
} from "@mui/material";

export default function Cards({ titulo, subtitulo, url, width, image, etiqueta, onClick }) {

  return (
    <Grid
       item
       xs={12}
       sm={12}
       md={3}
       lg={3}
      sx={{
        // display: "flex",
        // justifyContent: "center",
        // paddingLeft: "0 !important",

        //boxSizing: 'border-box',
        flexDirection: 'row',
        //margin: '0px',
        //flexGrow: 0,
        display: 'flex',
        justifyContent: 'center',
        padding: '12px 0 !important',
        //width: "100%"

        //flexBasis: isMobile ? '30%' : '25%',
        //maxWidth: isMobile ? '30%' : '25%',
      }}
    >
      <Card
        sx={{
          margin: "0 12px",
          height: 340,
          width: {sm:"80%", md:"100%"},
          maxWidth: {xs: "400px", md:"100%"},
          display: "flex",
          flexDirection: "column",
          transition: "transform 0.3s ease-in-out", 
          //will-change: transform;
          '&:hover': {
            transform: "scale(1.04)",
            transition: "transform 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
          }
        }}
      >
        <CardMedia
          sx={{
            height: 110,
            objectFit: "contain",
            display: "flex",
            justifyContent: "center",
            paddingTop: "10px",
          }}
          title="imagen"
        >
          <img src={image} alt="imagen" height="100px" />
        </CardMedia>
        <CardContent
          sx={{
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <div>
            <Typography
              gutterBottom
              variant="h6"
              component="div"
              align={"center"}
              color="secondary"
            >
              {titulo}
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              textAlign={"center"}
              sx={{
                fontSize:{sm:"17px", md:"16px"}
              }}
            >
              {subtitulo}
            </Typography>
          </div>
        </CardContent>
        <CardActions sx={{ display: "flex", justifyContent: "center" }}>
          <Button
            fullWidth
            variant="contained"
            sx={{ bgcolor: "#194AC1" }}
            onClick={onClick}
          >
            {etiqueta ? etiqueta : "Más información"}
          </Button>
        </CardActions>
      </Card>
    </Grid>
  );
}
